export const UPLOAD_WEIGHT_DISCREPANCY_REQUEST = "UPLOAD_WEIGHT_DISCREPANCY_REQUEST";
export const UPLOAD_WEIGHT_DISCREPANCY_SUCCESS = "UPLOAD_WEIGHT_DISCREPANCY_SUCCESS";
export const UPLOAD_WEIGHT_DISCREPANCY_FAILURE = "UPLOAD_WEIGHT_DISCREPANCY_FAILURE";
export const uploadWeightDiscrepancySuccess = (payload) => ({
    type: UPLOAD_WEIGHT_DISCREPANCY_SUCCESS,
    payload,
});
export const uploadWeightDiscrepancyRequest = (payload) => ({
    type: UPLOAD_WEIGHT_DISCREPANCY_REQUEST,
    payload,
});
export const uploadWeightDiscrepancyFailure = (payload) => ({
    type: UPLOAD_WEIGHT_DISCREPANCY_FAILURE,
    payload,
});
